import React from 'react'
import { Transfer as FormilyTransfer } from './Transfer'
import { createBehavior, createResource } from '@designable/core'
import { DnFC } from '@designable/react'
import { createFieldSchema } from '../Field'
import { AllSchemas } from '../../schemas'
import { AllLocales } from '../../locales'

export const Transfer: DnFC<React.ComponentProps<typeof FormilyTransfer>> =
  FormilyTransfer

Transfer.Behavior = createBehavior({
  name: 'Transfer',
  extends: ['Field'],
  selector: (node) => node.props['x-component'] === 'Transfer',
  designerProps: {
    propsSchema: createFieldSchema(AllSchemas.Transfer),
  },
  designerLocales: AllLocales.Transfer,
})

Transfer.Resource = createResource({
  icon: 'TransferSource',
  elements: [
    {
      componentName: 'Field',
      props: {
        title: '穿梭框',
        'x-decorator': 'FormItem',
        'x-component': 'Transfer',
        'x-component-props': {
          dataSource: [
            { label: '选项1', value: 1 },
            { label: '选项2', value: 2 },
          ],
        }
      },
    },
  ],
})
